module.exports = __webpack_public_path__ + "static/img/earth_spec.dc4fc60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/earth_spec.jpg
// module id = 165
// module chunks = 1